export default __webpack_public_path__ + "static/media/team-16-ico.4f549c51.svg";